export default __webpack_public_path__ + "static/media/brooke-cagle-g1Kr4Ozfoac-unsplash.be250b2a.jpg";